/*
 * @Author: cc
 * @LastEditTime: 2022-03-17 20:22:03
 */
import { useEffect, useState, useRef, } from "react";
import "./play.scss";
import { fetchGet, fetchPost } from "../../request";
import { useLocation, useHistory } from "react-router-dom";
import { VideoCameraOutlined } from "@ant-design/icons";
import { IsPC } from "../../utils/index";
import VideoJS from './video' 
import { message } from "antd";

// 高峰论坛userId
let playInfo = localStorage.getItem('playInfo')
let siteid = playInfo ? JSON.parse(playInfo).liveAccount : '';
const useQuery = () => {
  return new URLSearchParams(useLocation().search);
};

function Play(props: any) {
  const videoRef = useRef(null);
  const playerRef = useRef(null);
  const { options, onReady } = props;
  const videoJsOptions = { // lookup the options in the docs for more options
    autoplay: true,
    controls: true,
    responsive: true,
    fluid: true,
    playbackRates: [0.5, 1, 1.5, 2], //倍速设置
    html5: {   //去除画中画
      nativeControlsForTouch: false,
      nativePictureInPicture: false,
      disablePictureInPicture: true
    },
    controlBar: {
      pictureInPictureToggle: false
    },
    sources: [{
      src: 'http://192.168.1.161/shop/api/file/video/bf16ccc17f7aa3b430bde54093d5c040',
      type: 'application/x-mpegURL',
      label:'高清'
    },
    {
      src: 'http://192.168.1.161/shop/api/file/video/bf16ccc17f7aa3b430bde54093d5c040',
      type: 'application/x-mpegURL',
      label:'普通'
    },
   ]
  }

  const handlePlayerReady = (player:any) => {
    playerRef.current = player;

    // you can handle player events here
    player.on('waiting', () => {
      console.log('player is waiting');
    });

    player.on('dispose', () => {
      console.log('player will dispose');
    });
  };
  // const query = useQuery();
  // const history = useHistory();
  // const liveActivityId = query.get("liveActivityId");
  // const liveNum = query.get("liveNum");
  // const [videoList, setVideoList] = useState([]);
  // const [currentIndex, setCurrentIndex] = useState(0);
  // const getLiveVideoList = () => {
  //   fetchPost(`/shop/live/activity/getLiveVideoList`, {
  //     liveActivityId,
  //     liveNum,
  //   }).then((result) => {
  //     const { data, code, msg } = result;
  //     if (code !== 0) {
  //       message.error(msg);
  //       history.go(-1);
  //     } else {
  //       setVideoList(data);
  //       initVideo(data[currentIndex].ccVideoId);
  //     }
  //   });
  // };
  // const initVideo = (vid: string) => {
  //   if (window.createCCH5Player) {
  //     window.ccPlayerStatus = window.createCCH5Player({
  //       vid,
  //       siteid,
  //       autoStart: true,
  //       width: IsPC ? "80vw" : "100vw",
  //       height: IsPC ? "100vh" : "300px",
  //       banDrag: "false",
  //       playtype: 1,
  //       rate_allow_change: false,
  //       parentNode: document.getElementById("livePlayer"),
  //     });
  //   }
  // };
  // const init = () => {
  //   fetchGet('http://192.168.1.161:9000/hls/video/bf16ccc17f7aa3b430bde54093d5c040/bf16ccc17f7aa3b430bde54093d5c040.mp4/index.m3u8', {}).then(res => {
  //     console.log(res, '111111111')
  //   })
  // }
  // useEffect(() => {
  //   // getLiveVideoList();
  //   init()
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, []);

  return (
    <>
  
        <VideoJS options={videoJsOptions}  onReady={handlePlayerReady} />
      {/* <div
        className={"playInfo_box"}
        style={{
          flexDirection: IsPc ? "row" : "column",
        }}
      >
        <div id="livePlayer"></div>
        <div className="video_bottom_box">
          <div>
            <p>
              {videoList.map(
                (item: { title: string; ccVideoId: string }, index: number) => (
                  <div
                    className="classInfo_box"
                    key={index}
                    onClick={() => {
                      // setCurrentIndex(index);
                      // initVideo(item.ccVideoId);
                    }}
                  >
                    <p>
                      <VideoCameraOutlined />
                      &emsp;
                      <span className={currentIndex === index ? "check" : ""}>
                        {item.title}
                      </span>
                    </p>
                  </div>
                )
              )}
            </p>
          </div>
        </div>
      </div> */}
    </>
  );
}

export default Play;
